import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const customIcon = new L.Icon({
  iconUrl: "/img/logos.png",
  iconSize: [50, 50],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});
const AmigosDoLixoMap = () => {
  const coordenadas = [-22.805793378355098, -45.232823513513424];

  return (
    <div
      style={{ display: "flex", justifyContent: "center", margin: "40px 0" }}
    >
      <div
        style={{
          height: "500px",
          width: "700px",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 0 10px #aaa",
        }}
      >
        <MapContainer
          center={coordenadas}
          zoom={16}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          <Marker position={coordenadas} icon={customIcon}>
            <Popup width="100" height="120">
              <strong>Cooperativa Amigos do Lixo</strong>
              <br />
              Estr. Vicinal Dr. Rafael Américo Ranieri, 999
              <br />
              Santa Luzia, Guaratinguetá - SP
              <img
                src="/img/logos.png"
                alt="Logo Amigos do Lixo"
                class="logo-img"
              />{" "}
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};

export default AmigosDoLixoMap;
